import "core-js/modules/es6.regexp.search";

var url = require('url');

var prevPath = null;

function addTrailingSlash(path, removeQueryParams) {
  if (!path) {
    return path;
  }

  var parsedURL = url.parse(path);

  if (parsedURL.pathname.slice(-1) !== '/') {
    parsedURL.pathname += '/';
  }

  if (removeQueryParams) {
    // eslint-disable-next-line no-multi-assign -- directive added automatically by Shepherd migration
    parsedURL.hash = parsedURL.search = '';
  }

  return url.format(parsedURL);
}
/**
 * Interfaces with the NWA tracking library to log page view events.
 *
 * @param {String} curPath The current path we want to log.
 * @param {Boolean=false} logOnQueryParamChange Defaults to false.
 * If set, it will log page-view events on query change.
 */


export default function logPageView(curPath, logOnQueryParamChange) {
  // removeQueryParams will ignore query params when
  // determining if a new pageview event should be fired
  var removeQueryParams = !logOnQueryParamChange;
  var modifiedPrevPath = addTrailingSlash(prevPath, removeQueryParams);
  var modifiedCurPath = addTrailingSlash(curPath, removeQueryParams);
  var pathDidChange = modifiedPrevPath !== modifiedCurPath;
  var _window = window,
      nwa = _window.nwa; // Two checks before publishing page view event for logging:
  // 1. prevPath, if this is unset, that means we are in the callback for the initial route fired on
  //    page load. NWA logs pageviews on page load by default, so we don't want to dupe here.
  // 2. pathDidChange, see above
  // TODO provide an override to fire the initial PVE in cases where we're bypassing NWA.min.js'
  // initialize function

  if (prevPath && pathDidChange && nwa) {
    // This call should result in the following:
    // 1. Log to counter MySQL table
    // 2. Log to new pipeline
    // 3. Send google analytics page view
    nwa.track('PAGE_VIEW_EVENT');
  }

  prevPath = curPath;
}